/**
 * Function to determine if an element is in main section viewport.
 * @param {HTMLElement} node
 */
export const scrollIntoView = (node: HTMLElement) => {
    if (!(node instanceof HTMLElement)) return;

    const elementRect = node.getBoundingClientRect();

    const closestMainSection = node.closest(
        ".gw-rd-popup-widget-root-layout__main"
    );
    const closestMainSectionRect = closestMainSection?.getBoundingClientRect();

    if (
        closestMainSectionRect &&
        elementRect.bottom > closestMainSectionRect.bottom
    ) {
        node.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
        });
    }
};
